import { getUrlParams } from 'utility/Provide/Url';

export const getDestination = (destination: string) =>
    getUrlParams('ds') === 'h'
        ? false
        : destination.replace(/ *\([^)]*\) */g, '');

export const getType = (destination: string | false) => {
    switch (destination) {
        case 'Dominikanische Republik':
        case 'Schweiz':
        case 'Slowakei':
        case 'Ukraine':
        case 'Türkei':
        case 'Bahamas':
        case 'Faröer':
        case 'Niederlande':
        case 'Philippinen':
        case 'Karibik':
        case 'Kanaren':
        case 'Balearen':
            return 1;

        default:
            return 0;
    }
};

export default getDestination;
